<template>
<div>



    <div style="display: none; padding: 4px; background-color: #fafafa; margin-bottom: 10px;" :key="selectedSecondCat">
      1: {{ selectedFirstCat }}<br>2: {{ selectedSecondCat }}<br>3: {{ selectedThirdCat }}
    </div>

    <div class="catWrapper">

      <!-- First treeselect for main categories -->
      <div class="catContainer">
        <treeselect
          v-model="selectedFirstCat"
          :options="categoriesFirstLvl"
          :disable-branch-nodes="true"
          placeholder="erste Kategorie"
          @input="onSelectCategory($event, 'first')"
        />
        <button
          type="submit"
          class="button"
          @click="addCategory('FIRST')"
        >
          +
        </button>
      </div>

      <!-- Second treeselect for subcategories -->
      <div class="catContainer" v-if="selectedFirstCat != null">
        <span class="separator material-symbols-outlined">chevron_right</span>
        <treeselect
          v-model="selectedSecondCat"
          :options="categoriesSecondLvl"
          :disable-branch-nodes="true"
          placeholder="zweite Kategorie"
        />
        <button
          type="submit"
          class="button"
          @click="addCategory('SECOND')"
        >
          +
        </button>
      </div>

      <!-- Third treeselect for sub-subcategories -->
      <div class="catContainer" v-if="selectedSecondCat != null">
        <span class="separator material-symbols-outlined">chevron_right</span>
        <treeselect
          v-model="selectedThirdCat"
          :options="categoriesThirdLvl"
          :disable-branch-nodes="true"
          placeholder="dritte Kategorie"
        />
        <button
          type="submit"
          class="button"
          @click="addCategory('THIRD')"
        >
          +
        </button>
      </div>

    </div>

    <!-- Dialog for adding new category -->
    <modal
      title="Neue Kategorie anlegen"
      @close="closeDialog"
      cancel-text="Abbrechen"
      :is-show="showDialog"
      :backdrop-closable="false"
      :show-footer="true"
      :show-cancel="true"
      class="vcenter"
      width=640>

        <p>Bitte geben Sie hier den Namen für die neue Kategorie ein:</p><br>
        <form-input
          inputType="text"
          :showLabel="true"
          :label="'PIM-PRODUCT-CATEGORY-'+newCategoryType+'-LEVEL'"
          v-model.trim="newCategory"
        ></form-input>

      <div slot="footer">
          <span class="button" @click="closeDialog()">abbrechen</span>
          <span :class="['button is-primary', { 'is-disabled': !newCategory || newCategory.trim() == ''}, { 'is-loading': isSavingNewCategory }]" @click="addNewCategory()">speichern</span>
      </div>

    </modal>
</div>
</template>

<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
// import CollapsibleSection from "../../utils/CollapsibleSection.vue";

export default {
  name: "ProductSectionCategory",

  components: {
    Treeselect,
    // CollapsibleSection,
  },

  props: {
    pharmacy: { type: Object, default: null },
    initialCategoryId: { default: null },
    defaultOpen: { type: Boolean, default: false },
  },

  data() {
    return {
      categories: null,
      categoriesFirstLvl: null,
      selectedFirstCat: null,
      selectedSecondCat: null,
      selectedThirdCat: null,
      newCategory: null,
      newCategoryType: null,
      showDialog: false,
      isSavingNewCategory: false,
    };
  },

  async created() {
    await this.fetchCategories();

    if (this.initialCategoryId) {
      this.resolveInitialCategory(this.initialCategoryId);
    }
  },

  computed: {
    categoriesSecondLvl() {
      let arr = [];
      const mainCategory = this.categories
        ? this.categories.find((cat) => cat.id === this.selectedFirstCat)
        : null;

      if (mainCategory && mainCategory.children) {
        arr = mainCategory.children.map((cat) => ({
          id: cat.id,
          label: cat.name,
        }));
      }
      return arr;
    },

    categoriesThirdLvl() {
      let arr = [];
      if (!this.categories) return arr;

      const mainCategory = this.categories.find(
        (cat) => cat.id === this.selectedFirstCat
      );

      if (mainCategory && mainCategory.children) {
        const subCategory = mainCategory.children.find(
          (cat) => cat.id === this.selectedSecondCat
        );

        if (subCategory && subCategory.children) {
          arr = subCategory.children.map((cat) => ({
            id: cat.id,
            label: cat.name,
          }));
        }
      }
      return arr;
    },

    selectedCategory() {
      return this.selectedThirdCat
        ? this.selectedThirdCat
        : this.selectedSecondCat
          ? this.selectedSecondCat
          : this.selectedFirstCat;
    },
  },

  watch: {
    selectedFirstCat(val, oldVal) {
      if (val == null || (val != oldVal && oldVal != null)) {
        this.selectedSecondCat = null;
      }
    },

    selectedSecondCat(val, oldVal) {
      if (val == null || (val != oldVal && oldVal != null)) {
        this.selectedThirdCat = null;
      }
    },

    selectedCategory(val) {
      this.$emit("category-change", val);
    },
  },

  methods: {
    resolveInitialCategory(categoryId) {
      let foundCategories = this.getCategoryParents(this.categories, categoryId);

      if (foundCategories instanceof Array) {
        [this.selectedFirstCat, this.selectedSecondCat, this.selectedThirdCat] = foundCategories;
      } else {
        this.selectedFirstCat = foundCategories;
        this.selectedSecondCat = null;
        this.selectedThirdCat = null;
      }
    },

    onSelectCategory(node, type) {
      // placeholder
    },

    getCategoryParents(arr, id) {
      if (!arr) return null;
      for (let child of arr) {
        if (child.id === id) {
          return id;
        } else if (child.children && child.children.length > 0) {
          var x = this.getCategoryParents(child.children, id);
          if (x) return Array.isArray(x) ? [child.id, ...x] : [child.id, x];
        }
      }
    },

    findCategoryById(data, id) {
      for (let i = 0; i < data.length; ++i) {
        if (data[i].id == id) {
          return data[i];
        }
        if (data[i].children && data[i].children.length > 0) {
          const ret = this.findCategoryById(data[i].children, id);
          if (ret) return ret;
        }
      }
      return null;
    },

    addCategory(type) {
      this.showDialog = true;
      this.newCategoryType = type;
    },

    async addNewCategory() {
      if (this.newCategory.trim == "") {
        return;
      }

      let parentId = null;
      if (this.newCategoryType == "THIRD") {
        parentId = this.selectedSecondCat;
      } else if (this.newCategoryType == "SECOND") {
        parentId = this.selectedFirstCat;
      }

      let newCat = {
        name: this.newCategory,
        parent: parentId,
        site: this.pharmacy ? this.pharmacy.id : null,
      };

      this.isSavingNewCategory = true;

      this.entityCreateOrUpdate("pimCategory", newCat).then((res) => {
        if (this.newCategoryType == "THIRD") {
          this.selectedThirdCat = res.id;
        } else if (this.newCategoryType == "SECOND") {
          this.selectedSecondCat = res.id;
        } else if (this.newCategoryType == "FIRST") {
          this.selectedFirstCat = res.id;
        }

        this.fetchCategories().then(() => {
          this.isSavingNewCategory = false;
          this.showDialog = false;
          this.newCategory = "";
        });
      });
    },

    closeDialog() {
      this.showDialog = false;
      this.newCategory = "";
    },

    fetchCategories() {
      return this.axios
        .get(this.$config.api + "pimCategory/tree")
        .then((res) => {
          this.categories = res.data;

          this.categoriesFirstLvl = res.data.map((opt) => ({
            id: opt.id,
            label: opt.name,
          }));
        });
    },
  },
};
</script>

<style lang="scss">
::v-deep .vue-treeselect__multi-value-item {
  color: #000;
  background: #f5f7f9;
}

::v-deep .vue-treeselect__value-remove {
  color: #aaa;
}
</style>

<style scoped lang="scss">
.catWrapper {
  display: flex;
  flex-direction: row;
  gap: 10px;
  margin-bottom: 14px;

  .catContainer {
    display: flex;
    flex-direction: row;
    button {
      height: auto !important;
      margin-left: 4px;
    }

    .separator {
      height: auto !important;
      display: flex;
      align-items: center;
      margin-right: 10px;
      font-size: 18px;
      color: #999;
    }
  }
}
</style>
